import { Pipe, PipeTransform, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { QuestionResult } from '../models/user-detail-report-view';

@Pipe({
  name: 'formatStatus',
  standalone: true
})
export class FormatStatusPipe implements PipeTransform {
  private datePipe = inject(DatePipe);

  transform(questionResult: QuestionResult): string {
    return questionResult.status
      .replace(/([A-Z])/g, ' $1')
      .trim()
      .split('_')
      .map((word: string): string => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
}
